import React from 'react';
import Button from '@components/Button'
import PropTypes from 'prop-types';
import {
    Check
} from './index.style'
import IconTick from '@svgs/IconTick';

const Filter = ({item, setCurrentFilter, currentFilter}) => {

    const {title, filter} = item;

    const handleClick = () => {
        setCurrentFilter(filter);
    }

    return (
        <Button
            variant="outline"
            onClick={() => handleClick(filter)}
            color='filters'
            disabled={(currentFilter === filter)}
        >
            <Check active={(currentFilter === filter)}><IconTick /></Check>
            {title}
        </Button>
    );
};

Filter.propTypes = {
    item: PropTypes.object,
    setCurrentFilter: PropTypes.func,
    currentFilter: PropTypes.string,
    title: PropTypes.string,
    filter: PropTypes.string,
};

export default Filter;